import styled from 'styled-components';
import {GRID_WIDTH, GRID_HEIGHT} from '../../../config';

export const ContentContainer = styled.div`
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
    padding-top: ${GRID_HEIGHT/GRID_WIDTH * 100}%;
    width: 100%;
`;